import { NgbModule } from "@ng-bootstrap/ng-bootstrap";

import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { HttpModule } from "@angular/http";
import { HttpClientModule } from "@angular/common/http";

import { AppRoutingModule } from "./app-routing.module";
import { NgDragDropModule } from "ng-drag-drop";

import { AngularFireModule } from "angularfire2";
import { AngularFirestoreModule } from "angularfire2/firestore";

import { AppComponent } from "./app.component";

//components
import { NavbarComponent } from "./navbar/navbar.component";
import { FooterComponent } from "./footer/footer.component";
import { AboutComponent } from "./about/about.component";
import { CastsComponent } from "./casts/casts.component";
import { MemoryTableComponent } from "./memory game/memory-table/memory-table.component";
import { MemoryCardComponent } from "./memory game/memory-card/memory-card.component";
import { HomeComponent } from "./home/home.component";
import { DilemaGameComponent } from "./dilema-game/dilema-game.component";


import { NgxSmartModalModule } from 'ngx-smart-modal';

//services
import { DeckService } from "./memory game/memory-table/deck.service";
import { DilemaService } from "./dilema-game/dilema.service";
import { AnjalisQuizComponent } from "./anjalis-quiz/anjalis-quiz.component";
import { AuthService } from "./anjalis-quiz/auth.service";

//modals
import { NgbdModalConfigAnjalis } from "./modals/modal-basic-anjalis";
import { NgbdModalConfigDilema } from "./modals/modal-basic-dilema";
import { NgbdModalConfigMemory } from "./modals/modal-basic-memory";
import { NgbdModalConfigCasts } from "./modals/modal-basic-casts";

import * as firebase from "firebase";
import { NgxSmartModalComponent } from './ngx-smart-modal/ngx-smart-modal.component';

// Initialize Firebase
var config = {
  apiKey: "AIzaSyBvUk95l7ZqHgg0sEh58esNZeIYannJ180",
  authDomain: "nogetomdatabase.firebaseapp.com",
  databaseURL: "https://nogetomdatabase.firebaseio.com",
  projectId: "nogetomdatabase",
  storageBucket: "nogetomdatabase.appspot.com",
  messagingSenderId: "646553395089"
};
firebase.initializeApp(config);

@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    FooterComponent,
    AboutComponent,
    CastsComponent,
    MemoryTableComponent,
    MemoryCardComponent,
    HomeComponent,
    DilemaGameComponent,
    AnjalisQuizComponent,

    NgbdModalConfigAnjalis,
    NgbdModalConfigDilema,
    NgbdModalConfigMemory,
    NgbdModalConfigCasts,
    NgxSmartModalComponent,
  ],
  imports: [
    NgbModule,
    BrowserModule,
    FormsModule,
    HttpModule,
    AppRoutingModule,
    NgDragDropModule.forRoot(),
    HttpClientModule,

    AngularFireModule.initializeApp(config),
    AngularFirestoreModule,

    NgxSmartModalModule.forRoot()
  ],
  providers: [DeckService, DilemaService, AuthService],
  bootstrap: [AppComponent]
})
export class AppModule { }
